// File: src/components/general/Card/Card.tsx

import React from "react";
import styled from "styled-components";
import { Flex, FlexProps } from "../Flex";

/** 🧠 Omit variant from Flex to redefine it for Card */
export interface CardProps extends Omit<FlexProps, "variant"> {
  variant?: "soft" | "elevated" | "outline" | "glass";
  as?: any; 
  $swipeDirection?: "left" | "right" | null; 

}

const StyledCard = styled(Flex)<CardProps>`
  position: relative;
  width: 100%;
  overflow: hidden;
  transition: all 0.3s ease;

  

  ${({ theme, variant }) => {
    switch (variant) {
      case "elevated":
        return `
          background: ${theme.colors.surface};
          box-shadow: ${theme.elevations.md};
          border-radius: ${theme.radii.lg};
        `;
      case "outline":
        return `
          background: ${theme.colors.surface};
          border: 1px solid ${theme.colors.border};
          border-radius: ${theme.radii.lg};
        `;
      case "glass":
        return `
          background: ${theme.colors.surfaceGlass};
          backdrop-filter: blur(12px);
          border-radius: ${theme.radii.lg};
          border: 1px solid ${theme.colors.borderGlass};
        `;
      case "soft":
      default:
        return `
          background: ${theme.colors.surface};
          border-radius: ${theme.radii.md};
          box-shadow: ${theme.elevations.low};
        `;
    }
  }}

  ${({ $swipeDirection, theme }) =>
    $swipeDirection &&
    `
      border: 0.5px dashed ${theme.colors[$swipeDirection === "left" ? "error" : "success"]};
      background:  ${theme.colors[$swipeDirection === "left" ? "error" : "success"]};
      transform: scale(1.02);
    `}
    
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.elevations.high};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.spacing.md};
  }
`;

export const Card: React.FC<CardProps> = ({
  children,
  padding = "lg",
  gap = "md",
  direction = "column",
  variant = "soft",
  responsive = true,
  as,

  ...props
}) => {
  return (
    <StyledCard
      as={as} 
      padding={padding}
      gap={gap}
      direction={direction}
      variant={variant}
      responsive={responsive}
      {...props}
    >
      {children}
    </StyledCard>
  );
};